// extracted by mini-css-extract-plugin
export default {"PaymentMethodValue":"PaymentMethodValue_PaymentMethodValue","Select-value":"PaymentMethodValue_Select-value","icon":"PaymentMethodValue_icon"};